import React, { useContext, useEffect, useState } from 'react';
import { Form, Col, Tabs, Tab, Button, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import api from '../../../api';
import { ModalContext } from '../../../contexts/modal';
import { BusinessContext } from '../../../contexts/business';
import { trackPromise } from 'react-promise-tracker';
import ButtonLoader from '../../../components/ButtonLoader';
import firebase from "firebase";
// import styledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { useHistory } from 'react-router-dom';
import RichGooglePlacesAutoComplete from "../../../autocomplete/RichGooglePlacesAutoComplete";


const FormSellerIndividual = ({ onFormSubmit, id, userType }) => {
    const { handleModalClose, onSubmitButtonHide, SubmitButtonShow } = useContext(ModalContext);
    const { businessCategories } = useContext(BusinessContext);
    const [tabKey, setTabKey] = useState('signup-options');
    const [ID, setID] = useState(false);
    const [checkID, setcheckID] = useState(false);
    const [showPasword, setShowPassword] = useState(false);
    const [showConfirmPasword, setShowConfirmPasword] = useState(false);
    const history = useHistory();

    const [alert, setAlert] = useState(false);
    const [loginEmail, setloginEmail] = useState("");
    const [authSource, setAuthSource] = useState("email");
    const [userId, setUserId] = useState("");
    const [alertMessage, setAlertMessage] = useState('');




    const [formValues, setformValues] = useState({
        shopName: "",
        email: "",
        cellNumber: "",
        city: "",
        area: "",
        gender: "",
        salesRepresentationID: "",
        referenceID: "",
        password: "",
    });

    const validSchema1 = Yup.object().shape({
        shopName: Yup.string().required("Required"),
        email: Yup.string().email().required("Required"),
        cellNumber: Yup.string().required("Required").max(11, 'Phone must contain 11 numbers').min(11, 'Phone must contain 11 numbers'),
        city: Yup.string().required("Required"),
        // area: Yup.string().required("Required"),
        gender: Yup.string().required("Required"),
        password: Yup.string().required("Required").min(8, "Your password must be at least 8 characters long"),
        conPassword: Yup.string().required('required').oneOf([Yup.ref("password"), null], "Passwords must match").min(8, "Confirm password must be at least 8 characters long"),
        // businessCategories: Yup.string()
    });
    const validSchema2 = Yup.object().shape({
        salesRepresentationID: Yup.string().max(10, 'Sales Representation ID must contain 11 numbers').min(10, 'Sales Representation ID must contain 11 numbers'),
        referenceID: Yup.string().max(10, 'Reference ID must contain 11 numbers').min(10, 'Reference ID  must contain 11 numbers')
    });

    const onChangeID = (e, formik) => {
        formik.handleChange(e);
        if (e.target.value === 'yes') {
            ID === false ? setID(true) : setID(true)
            setcheckID(true)
        }
        if (e.target.value === 'no') {
            ID === true ? setID(false) : setID(false)
            setformValues({ ...formValues, salesRepresentationID: "", referenceID: "" })
            setcheckID(true)
        }
    }

    const onBackForm2 = () => {
        onSubmitButtonHide()


        setAlert(false);
        setTabKey("form1")
    }
    const handleShowPassword = () => {
        showPasword ? setShowPassword(false) : setShowPassword(true)
    }

    const handleShowConfirmPassword = () => {
        showConfirmPasword ? setShowConfirmPasword(false) : setShowConfirmPasword(true)
    }

    function onFormSubmit1(values) {
        const { shopName, email, cellNumber, city, area, gender, password } = values;
        console.log(shopName, email, cellNumber, city, area, gender, password)
        setformValues({ ...formValues, shopName: shopName, email: email, cellNumber: cellNumber, city: city, area: area, gender: gender, password: password });
        setloginEmail(email);
        setTabKey("form2");
        SubmitButtonShow();
    }
    async function onSubmit(values) {
        console.log("userId:", userId);
        try {
            if (checkID) {
                const { salesRepresentationID, referenceID } = values;
                setformValues({ ...formValues, salesRepresentationID, referenceID })
                console.log("authsource:", authSource)
                await api.post("/auth/signup", {
                    ...formValues,
                    email: loginEmail,
                    role: 'seller',
                    authSource: authSource,
                    userId: userId,
                    userType
                });
                setTabKey("registeration-finish")
                onSubmitButtonHide();
                console.log("dd", ...formValues)
            }
        } catch (error) {
            setAlert(true);
            setAlertMessage(error.response.data.message);
            setformValues({ shopName: "", email: "", cellNumber: "", city: "", area: "", gender: "" });

        }
    };

    const uiConfig = {
        signInFlow: "popup",
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            signInSuccess: async (currentUser, credential, redirectUrl) => {
                console.log("current user", currentUser.uid)
                console.log("current user", currentUser.providerData[0].providerId)

                currentUser.providerData[0].providerId === "facebook.com" ? setAuthSource("facebook") : setAuthSource("google");
                ;
                // loginSuccess(res.data.token);
                setloginEmail(currentUser.email);
                setUserId(currentUser.uid)
                redirectUrl = setTabKey("form1");
                return false;
            },
        }
    }

    useEffect(() => {
        onSubmitButtonHide()
    }, [])
    return (

        <Tabs
            defaultActiveKey={tabKey}
            transition={false}
            id="noanim-tab-example"
            className="my-tabs"
        >
            <Tab eventKey="signup-options" title="" active={tabKey === "signup-options" ? true : false} >
                <Col md={6} sm={12} style={{ margin: "auto" }}>
                    <Button className="section-signin__login-btn button btn-block rounded-0" type="submit" form="login" onClick={() => setTabKey("form1")}>Signup With Email</Button>
                    <p className="mt-1 mb-0">Or, with</p>
                    <StyledFirebaseAuth className="firebase-ui-cus" uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                </Col>
            </Tab>
            <Tab eventKey="form1" title="" active={tabKey === "form1" ? true : false}>
                <Formik
                    onSubmit={onFormSubmit1}
                    validationSchema={validSchema1}
                    enableReinitialize
                    initialValues={{
                        shopName: formValues.shopName,
                        email: loginEmail,
                        cellNumber: formValues.cellNumber,
                        city: formValues.city,
                        area: formValues.area,
                        gender: formValues.gender,
                        businessCategories: "",
                        password: formValues.password,
                        conPassword: "",
                    }}
                >
                    {(formik) => (
                        <Form
                            onSubmit={formik.handleSubmit}
                            id="registerform1"
                        >
                            <Form.Row>
                                <Form.Group controlId="shopName" as={Col} hasValidation>
                                    <Form.Label className="form__label">Business Name</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="shopName"
                                        placeholder="Enter Business Name"
                                        value={formik.values.shopName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.shopName && !formik.errors.shopName}
                                        isInvalid={formik.touched.shopName && formik.errors.shopName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.shopName}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="email" as={Col} hasValidation>
                                    <Form.Label className="form__label">Email</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="email"
                                        name="email"
                                        placeholder="Enter Email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.email && !formik.errors.email}
                                        isInvalid={formik.touched.email && formik.errors.email}
                                        disabled={authSource !== "email" ? true : false}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </Form.Row>

                            <Form.Row>
                                <Form.Group controlId="cellNumber" as={Col} hasValidation>
                                    <Form.Label className="form__label">Mobile</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="cellNumber"
                                        placeholder="03xxxxxxxxx"
                                        value={formik.values.cellNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.cellNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="city" as={Col} hasValidation>
                                    <Form.Label className="form__label">City</Form.Label>
                                    {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="string"
                                        name="city"
                                        placeholder="Enter City"
                                        value={formik.values.city}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.city && !formik.errors.city}
                                        isInvalid={formik.touched.city && formik.errors.city}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.city}
                                    </Form.Control.Feedback> */}
                                    <RichGooglePlacesAutoComplete defaultValue={formik.values.city} placeholder="  City" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('city', description);
                                        // setformValues({ ...formValues, city: description })
                                    }} />
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                {/* <Form.Group controlId="area" as={Col} hasValidation>
                                    <Form.Label className="form__label">Area</Form.Label> */}
                                {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="area"
                                        placeholder="Enter Area"
                                        value={formik.values.area}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.area && !formik.errors.area}
                                        isInvalid={formik.touched.area && formik.errors.area}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.area}
                                    </Form.Control.Feedback> */}
                                {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  Area" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('area', description);
                                        // setformValues({ ...formValues, area: description })
                                    }} />
                                </Form.Group> */}

                                <Form.Group controlId="gender" as={Col} hasValidation>
                                    <Form.Label className="form__label">Gender</Form.Label>
                                    <Form.Control
                                        className="rounded-0"
                                        as="select"
                                        name="gender"
                                        placeholder="Enter Gender"
                                        value={formik.values.gender}
                                        onChange={(e) => formik.handleChange(e)}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.gender && !formik.errors.gender}
                                        isInvalid={formik.touched.gender && formik.errors.gender}
                                        custom
                                    >
                                        <option value="" disabled>CHOOSE</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.gender}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="businessCategories" as={Col} hasValidation>
                                    <Form.Label className="form__label">Business Category</Form.Label>
                                    <Form.Control
                                        className="rounded-0"
                                        as="select"
                                        name="businessCategories"
                                        placeholder="Enter businessCategories"
                                        value={formik.values.businessCategories}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.businessCategories && !formik.errors.businessCategories}
                                        isInvalid={formik.touched.businessCategories && formik.errors.businessCategories}
                                        custom
                                    >
                                        <option value="" disabled>CHOOSE</option>
                                        {businessCategories.map(businessCategory => {
                                            return <option value={businessCategory.id} key={businessCategory.id}>{businessCategory.title}</option>
                                        })}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.businessCategories}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group controlId="password" as={Col} hasValidation>
                                    <Form.Label className="form__label">Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0 "
                                            // style={{backG}}
                                            type={showPasword ? "text" : "password"}
                                            name="password"
                                            autoComplete="new-password"
                                            style={{ backgroundImage: 'none' }}
                                            placeholder="Please Enter Your Password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.password && !formik.errors.password}
                                            isInvalid={formik.touched.password && formik.errors.password}
                                        />
                                        {

                                            showPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }} ></i>
                                        }
                                    </div>
                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="conPassword" as={Col} hasValidation>
                                    <Form.Label className="form__label">Confirm Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0"
                                            type={showConfirmPasword ? "text" : "password"}
                                            name="conPassword"
                                            placeholder="Please Enter Confirm Password"
                                            value={formik.values.conPassword}
                                            style={{ backgroundImage: 'none' }}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.conPassword && !formik.errors.conPassword}
                                            isInvalid={formik.touched.conPassword && formik.errors.conPassword}
                                        />
                                        {

                                            showConfirmPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }} ></i>
                                        }
                                    </div>

                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.conPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Button className="button" type="submit" style={{ float: "right" }}>
                                Next
                            </Button>
                        </Form>
                    )
                    }
                </Formik >
            </Tab>


            <Tab eventKey="form2" title="" active={tabKey === "form2" ? true : false}>
                <Formik
                    onSubmit={(values) => trackPromise(onSubmit(values), 'register')}
                    validationSchema={validSchema2}
                    enableReinitialize
                    initialValues={{
                        salesRepresentationID: '',
                        referenceID: ''
                    }}
                >
                    {(formik) => (
                        <Form
                            onSubmit={formik.handleSubmit}
                            id={id}
                        >
                            <Form.Row>
                                <Form.Group controlId="referenceAndSalesId" as={Col} hasValidation>
                                    {
                                        alert ?
                                            <Alert variant="danger" className="rounded">{alertMessage}</Alert>
                                            : ""
                                    }
                                    <Form.Label className="form__label">Are you registering through Sales representative or Affiliate / Influencer?
                                    </Form.Label>
                                    <Form.Check

                                        label="Yes"
                                        type="radio"
                                        id={`inline-checkbox-1`}
                                        className="rounded-0"
                                        name="referenceAndSalesId"
                                        value="yes"
                                        onChange={(e) => onChangeID(e, formik)}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.referenceAndSalesId && !formik.errors.referenceAndSalesId}
                                        isInvalid={formik.touched.referenceAndSalesId && formik.errors.referenceAndSalesId}
                                        // checked={formCheck.check1 === true ? true : false}
                                        custom
                                    >
                                    </Form.Check>

                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.referenceAndSalesId}
                                    </Form.Control.Feedback>
                                    <Form.Check
                                        label="No"
                                        type="radio"
                                        id={`inline-checkbox-2`}
                                        className="rounded-0"
                                        name="referenceAndSalesId"
                                        value="no"
                                        onChange={(e) => onChangeID(e, formik)}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.referenceAndSalesId && !formik.errors.referenceAndSalesId}
                                        isInvalid={formik.touched.referenceAndSalesId && formik.errors.referenceAndSalesId}
                                        // checked={formCheck.check2 === true ? true : false}
                                        custom
                                    >
                                    </Form.Check>

                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.referenceAndSalesId}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            {
                                ID ?
                                    <Form.Row>
                                        <Form.Group controlId="salesRepresentationID" as={Col} hasValidation>
                                            <Form.Label className="form__label">Sales Representative ID / Mobile no.</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="number"
                                                name="salesRepresentationID"
                                                placeholder="Enter Sales Representative ID / Mobile no"
                                                value={formik.values.salesRepresentationID}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.salesRepresentationID && !formik.errors.salesRepresentationID}
                                                isInvalid={formik.touched.salesRepresentationID && formik.errors.salesRepresentationID}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.salesRepresentationID}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="referenceID" as={Col} hasValidation>
                                            <Form.Label className="form__label">Affiliate / Influencer ID / Mobile no. </Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="number"
                                                name="referenceID"
                                                placeholder="Enter Affiliate / Influencer ID / Mobile no"
                                                value={formik.values.referenceID}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.referenceID && !formik.errors.referenceID}
                                                isInvalid={formik.touched.referenceID && formik.errors.referenceID}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.referenceID}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    : ""
                            }
                            <Button className="button" style={{ float: "right" }} onClick={onBackForm2} >
                                Back
                            </Button>
                        </Form>
                    )}
                </Formik>
            </Tab>
            <Tab eventKey="registeration-finish" title="" active={tabKey === "registeration-finish" ? true : false}>
                <div>
                    <span style={{ fontSize: '20px', lineHeight: '1.8' }}>
                        <h4>Welcome to Subka Faida.</h4>
                        <span>
                            Thank you for registering with us.<br /> We have received your details and really appreciate for your time. We are confident to upscale your business and to increase sales.<br />One of our colleagues will be in contact with you soon!
                        </span>
                    </span>
                </div>
                {/* <a href={`${process.env.REACT_APP_VENDOR_PANEL_URL}/auth/signin`}>
                    <Button className="button" type="submit" style={{ float: "right" }}>
                        Go to vendor panel
                    </Button>
                </a> */}
            </Tab >

        </Tabs >
    )
}

export default FormSellerIndividual;